<div>
  <kendo-grid
    [kendoGridBinding]="gridData"
    #grid
    [resizable]="true"
    [sortable]="true"
    [sort]="sort"
    [pageSize]="pageSize"
    [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"
    [scrollable]="true"
    (pageChange)="pageChange($event)"
    style="height: 73vh">
    <ng-template kendoGridToolbarTemplate style="height:100px">
      <h1> GL Guide #{{this.glGuideService._glguide}} {{this.glGuideService.glguidedescription}}</h1>
      <div class="gl-print-btns" fxFlex fxLayout="row" fxLayoutAlign="end end">
      <app-mcl-button id="but-export" (buttonPressed)="exportToPDF(grid)" type="button" icon="file-pdf"
      primary="true" text="Export to PDF"></app-mcl-button>

    <app-mcl-button id="but-export-excel" (buttonPressed)="exportToExcel(grid)" icon="file-excel" primary="true"
      text="Export to Excel"></app-mcl-button>
      <kendo-grid-column-chooser style="float:right"></kendo-grid-column-chooser>
      </div>
    </ng-template>
    <kendo-grid-column field="glasq" title="GL Sequence" [width]="100"></kendo-grid-column>
    <kendo-grid-column field="glcode" title="GL Code" [width]="100"></kendo-grid-column>
    <kendo-grid-column field="itemSub" title="GL Description" [width]="150"></kendo-grid-column>
    <kendo-grid-column field="itemNo" title="Item No" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.itemNo | number: '6.' | noComma}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="itemDesc" title="Item Description" [width]="150"></kendo-grid-column>


      <!-- Pdf Export -->
      <kendo-grid-pdf fileName="GlReview.pdf" [author]="'McLane'" [producer]="'McLane'" paperSize="A4"
      [repeatHeaders]="false" [landscape]="true" [scale]="scale" [allPages]="true">
      <kendo-grid-column field="glasq" title="GL Sequence" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="glcode" title="GL Code" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="itemSub" title="GL Description" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="itemNo" title="Item No" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="itemDesc" title="Item Description" [width]="150"></kendo-grid-column>

      <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
      <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
        <div class="page-template">
          <div class="header">
            <div style="float: right">
              Page {{ pageNum }} of {{ totalPages }}
            </div>
            <p> Online-Invoice - GL-Review Guide</p>
          </div>
        </div>
      </ng-template>
    </kendo-grid-pdf>

     <!-- Excel Export -->
     <kendo-grid-excel fileName="GlReview.xlsx" [fetchData]="exportAllData">
             <kendo-excelexport-column field="glasq" title="GL Sequence">
             </kendo-excelexport-column>
             <kendo-excelexport-column field="glcode" title="GL Code">
             </kendo-excelexport-column>
             <kendo-excelexport-column field="itemSub" title="GL Description">
             </kendo-excelexport-column>
             <kendo-excelexport-column field="itemNo" title="Item No">
             </kendo-excelexport-column>
             <kendo-excelexport-column field="itemDesc" title="Item Description">
             </kendo-excelexport-column>
    </kendo-grid-excel>

  </kendo-grid>
  <div kendoDialogContainer></div>
</div>
